import React from 'react';
import { Page, StyleSheet, Font } from '@react-pdf/renderer';
import { Fonts } from 'react-pdf-builder';
import colors from '@/design/colors';

// Register Source Sans Pro for use in the PDF
// Register Source Sans Pro and Cambria for use in the PDF
Font.register({
  family: 'Source Sans Pro',
  fonts: [
    {
      src:
        'https://cdn.jsdelivr.net/npm/source-sans-pro@3.6.0/TTF/SourceSansPro-Regular.ttf',
    },
    {
      src:
        'https://cdn.jsdelivr.net/npm/source-sans-pro@3.6.0/TTF/SourceSansPro-Bold.ttf',
      fontWeight: 'bold',
    },
    {
      src:
        'https://cdn.jsdelivr.net/npm/source-sans-pro@3.6.0/TTF/SourceSansPro-It.ttf',
      fontStyle: 'italic',
    },
    {
      src:
        'https://cdn.jsdelivr.net/npm/source-sans-pro@3.6.0/TTF/SourceSansPro-BoldIt.ttf',
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
});

Font.registerEmojiSource(Fonts.emojis.twemoji());

const styles = StyleSheet.create({
  page: {
    // Flex
    flexDirection: 'column',
    rowGap: 8,

    // Spacing
    paddingTop: 36,
    paddingHorizontal: 36,
    paddingBottom: 160, // To avoid footer overlap

    // Default font
    fontFamily: 'Source Sans Pro',
    fontSize: 9,
    color: colors.blackAlpha200,
  },
});

type DocumentPageProps = React.PropsWithChildren & {
  wrap?: boolean;
  debug?: boolean;
};

const DocumentPage: React.FC<DocumentPageProps> = ({
  children,
  wrap = true,
  debug = false,
}) => {
  return (
    <Page size="A4" debug={debug} wrap={wrap} style={styles.page}>
      {children}
    </Page>
  );
};

export default DocumentPage;
